module.exports = __webpack_public_path__ + "img/score_5.b61580f7.png";